import * as React from "react";
import InsertDot from "./InsertDot";
import Header from "./Header";
import { useSelector } from "react-redux";
import { getTemplateDefs } from "../../helpers/grid";

const ColumnHeaders = () => {
  const cols = useSelector((state) => state.gridd.present.structure.columns);
  const readOnly = useSelector((state) => state.app.readOnlyMode);

  return (
    <div
      id="col_headers"
      style={{
        display: "grid",
        height: "28px",
        gridTemplateColumns: getTemplateDefs(cols),
        zIndex: 999,
      }}
    >
      {cols ? (
        cols.map((col, j) =>
          col[0] !== "b" ? (
            <div
              key={j}
              style={{
                height: 28,
                display: "flow",
                position: "relative",
              }}
            >
              {!readOnly ? (
                <>
                  <InsertDot vertical={true} index={j} />
                  <Header vertical={true} index={j} />
                  {j == cols.length - 1 ? (
                    <div
                      style={{
                        float: "right",
                        position: "relative",
                        top: -12,
                        // left: 3,
                        right: 12,
                      }}
                    >
                      <InsertDot vertical={true} index={j + 1} isLast={j == cols.length - 1} />
                    </div>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <div key={j} />
          )
        )
      ) : (
        <></>
      )}
    </div>
  );
};

export default ColumnHeaders;
